const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "agentName_contains",
      label: "Agent",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "tagsList_contains",
      label: "Tags",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DepartmentMultiFilter"),
    props: {
      filterName: "departments_eq",
      label: "Department",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/BooleanFilter"),
    props: {
      filterName: "not_in_use_eq",
      label: "Not In Use",
      filterValue: false,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "destinationName_contains",
      label: "Destination Name",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    main: true,
    props: {
      filterName: "validFrom",
      label: "Valid from date between",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    main: true,
    props: {
      filterName: "validTo",
      label: "Valid to date between",
      filterValue: null,
    },
  },
  /*,
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DateFilter"),
    props: {
      filterName: "validTo_gte",
      label: "Valid",
      filterValue: new Date(),
    },
  },*/
];



// WEBPACK FOOTER //
// ./src/components/gt/plugins/markups/list-filters.js